import { PureComponent } from 'react';
import { ErrorContext, ErrorContextProvider } from '../../contexts/error/context';
import captureException from '../../utils/captureException';
import ErrorModal from './ErrorModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ModalErrorWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error) {
    this.setState({
      hasError: true
    });
    captureException(error);
  }
  render() {
    const {
      showError,
      message,
      children,
      ctaFunction
    } = this.props;
    const {
      hasError
    } = this.state;
    if (hasError) return /*#__PURE__*/_jsx(ErrorModal, {
      message: message,
      ctaFunction: ctaFunction
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [showError && /*#__PURE__*/_jsx(ErrorModal, {
        message: message,
        ctaFunction: ctaFunction
      }), children]
    });
  }
}
const WrappedModalErrorWrapper = ({
  children,
  appName
}) => /*#__PURE__*/_jsx(ErrorContextProvider, {
  appName: appName,
  children: /*#__PURE__*/_jsx(ErrorContext.Consumer, {
    children: props => /*#__PURE__*/_jsx(ModalErrorWrapper, Object.assign({}, props, {
      children: children
    }))
  })
});
export default WrappedModalErrorWrapper;